import { useEffect, useRef } from "react";

export type BindInspectionStepSave = (save: (() => void) | null) => void;

/**
 * Liga o `handleSave` do step ao rodapé wizard da ficha. Sem `onBindSave`
 * (specs isolados do step) o botão interno permanece visível.
 */
export const useBindInspectionStepSave = (
  onBindSave: BindInspectionStepSave | undefined,
  save: () => void,
  enabled: boolean,
) => {
  const saveRef = useRef(save);
  saveRef.current = save;

  useEffect(() => {
    if (!onBindSave || !enabled) return;

    onBindSave(() => saveRef.current());
    return () => onBindSave(null);
  }, [onBindSave, enabled]);
};
